"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostUserResponse = instanceOfApiPostUserResponse;
exports.ApiPostUserResponseFromJSON = ApiPostUserResponseFromJSON;
exports.ApiPostUserResponseFromJSONTyped = ApiPostUserResponseFromJSONTyped;
exports.ApiPostUserResponseToJSON = ApiPostUserResponseToJSON;
exports.ApiPostUserResponseToJSONTyped = ApiPostUserResponseToJSONTyped;
/**
 * Check if a given object implements the ApiPostUserResponse interface.
 */
function instanceOfApiPostUserResponse(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ApiPostUserResponseFromJSON(json) {
    return ApiPostUserResponseFromJSONTyped(json, false);
}
function ApiPostUserResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
        'message': json['message'],
    };
}
function ApiPostUserResponseToJSON(json) {
    return ApiPostUserResponseToJSONTyped(json, false);
}
function ApiPostUserResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'message': value['message'],
    };
}
